
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.37539 12.1748L13.1395 11.2498L14.7121 15.9498L9.37539 12.1748ZM18.0379 6.0998H11.4121L9.37539 0.0498047L7.33867 6.0998H0.712891L6.07539 9.8498L4.03867 15.8998L9.40117 12.1498L12.7012 9.8498L18.0379 6.0998Z","fill":"white"}})])
          )
        }
      }
    